import React from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router-dom'
import './UserRole.sass'

class UserRole extends React.PureComponent {
  /* eslint-disable */
  static propTypes = {
    current_user: PropTypes.object.isRequired,
    listRoles: PropTypes.array.isRequired
  }
  /* eslint-disable */

  render () {
    const {listRoles, current_user} = this.props
    return (
      <div className="dropdown__row-topRoles">
        <p>Выберите роль:</p>
        {listRoles.map((listRole) => {
            return (
              <a
                key={listRole.role}
                className={(current_user.role === listRole.role) ? 'nav-list__item_active' : ''}
              >
                {listRole.name}
              </a>
            )
        })}
      </div>
    )
  }
}

export default withRouter(UserRole)



// WEBPACK FOOTER //
// ./components/DropdownUser/UserRole.jsx